// const pushServerPublicKey =
// "BIN2Jc5Vmkmy-S3AUrcMlpKxJpLeVRAfu9WBqUbJ70SJOCWGCGXKY-Xzyh7HDr6KbRDGYHjqZ06OcS3BjD7uAm8";

const pushServerPublicKey = new Uint8Array([
  0x04,
  0xd0,
  0x3d,
  0x5c,
  0xdc,
  0xfe,
  0x72,
  0x71,
  0x88,
  0x62,
  0x12,
  0xe1,
  0x46,
  0x46,
  0x56,
  0x74,
  0x69,
  0x05,
  0x29,
  0x97,
  0xe0,
  0xe8,
  0xb0,
  0xfa,
  0x50,
  0x40,
  0x83,
  0x8c,
  0x4e,
  0xc0,
  0x7b,
  0x90,
  0x42,
  0xa7,
  0x61,
  0xe0,
  0xc5,
  0x32,
  0xd6,
  0xd4,
  0x8c,
  0x9c,
  0x33,
  0x7b,
  0xeb,
  0x6e,
  0xbd,
  0x48,
  0xa7,
  0x42,
  0x95,
  0x3a,
  0x92,
  0xb9,
  0x2a,
  0x47,
  0x5b,
  0xef,
  0x03,
  0x84,
  0xc4,
  0x95,
  0x43,
  0xf1,
  0xad,
]);

/**
 * checks if Push notification and service workers are supported by your browser
 */
function isPushNotificationSupported() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

/**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */
async function askUserPermission() {
  return await Notification.requestPermission();
}
/**
 * shows a notification
 */
function sendNotification() {
  const img = "/images/jason-leung-HM6TMmevbZQ-unsplash.jpg";
  const text = "Take a look at this brand new t-shirt!";
  const title = "New Product Available";
  const options = {
    body: text,
    icon: "/images/jason-leung-HM6TMmevbZQ-unsplash.jpg",
    vibrate: [200, 100, 200],
    tag: "new-product",
    image: img,
    badge: "https://spyna.it/icons/android-icon-192x192.png",
    actions: [
      {
        action: "Detail",
        title: "View",
        icon: "https://via.placeholder.com/128/ff0000",
      },
    ],
  };
  navigator.serviceWorker.ready.then(function (serviceWorker) {
    serviceWorker.showNotification(title, options);
  });
}

/**
 *
 */

/**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */
async function createNotificationSubscription() {
  //wait for service worker installation to be ready
  const serviceWorker = await navigator.serviceWorker.ready;
  // subscribe and return the subscription
  return await serviceWorker.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: pushServerPublicKey,
  });
}

/**
 * returns the subscription if present or nothing
 */
function getUserSubscription() {
  //wait for service worker installation to be ready, and then
  return navigator.serviceWorker.ready
    .then(function (serviceWorker) {
      return serviceWorker.pushManager.getSubscription();
    })
    .then(function (pushSubscription) {
      return pushSubscription;
    });
}

export {
  isPushNotificationSupported,
  askUserPermission,
  sendNotification,
  createNotificationSubscription,
  getUserSubscription,
};
